const ENRICHMENT_HINTS = {
  delievery_point:
    'The last two digits of the house/box number, unless an "H" record is matched, in which case this is the secondary unit number representing the delivery point information to form the delivery point barcode (DPBC).',
  carrier_route:
    "The postal carrier route for the address. Consists of a one-letter prefix followed by a three-digit route designator.",
  cmra:
    "Indicates whether the address is associated with a Commercial Mail Receiving Agency (CMRA), also known as a private mailbox (PMB) operator. A CMRA is a business through which USPS mail may be sent or received, for example the UPS Store and Mailboxes Etc.",
  county_fips:
    "The 5-digit county FIPS (Federal Information Processing Standards) code. It is a combination of a 2-digit state FIPS code and a 3-digit county code assigned by the NIST (National Institute of Standards and Technology).",
  delivery_point:
    'The last two digits of the house/box number, unless an "H" record is matched, in which case this is the secondary unit number representing the delivery point information to form the delivery point barcode (DPBC)',
  delivery_point_check_digit:
    "Correction character, or check digit, for the 11-digit barcode",
  dpv_footnotes:
    "Indicates why the address was given its DPV value and potentially the type of ZIP Code that was matched. All these footnotes have a length of 2 characters, and there may be up to 14 footnotes.",
  elot_sequence: "Enhanced Line of Travel 4-digit sequence number",
  elot_sort:
    "eLOT (Enhanced Line of Travel) product was developed to give mailers the ability to sort their mailings by line of travel sequence.",
  record_type:
    "Indicates the type of record that was matched. Only given if a DPV match is made. \n F — Firm; the finest level of match available for an address.\n" +
    "(e.g., Julie Julia 11300 Center Ave Gilroy CA 95020-9257)\n" +
    "G — General Delivery; for mail to be held at local post offices.\n" +
    "(e.g., General Delivery Provo UT 84601)\n" +
    "H — High-rise; address contains apartment or building sub-units.\n" +
    "(e.g., 1600 Pennsylvania Ave SE Washington DC 20003-3228)\n" +
    "P — Post Office box; address is a PO Box record type.\n" +
    "(e.g., PO Box 4735 Tulsa OK 74159-0735)\n" +
    "R — Rural Route or Highway Contract; may have box number ranges.\n" +
    "(e.g., RR 2 Box 4560 Anasco PR 00610-9393)\n" +
    "S — Street; address contains a valid primary number range.\n" +
    "(e.g., 16990 Monterey Rd Lake Elsinore CA 92530-7529)\n" +
    "[blank] — No record type because address did not make a valid DPV match"
};

const ENRICHMENT_MAP = {
  cmra: "CMRA",
  dpv_footnotes: "DPV Footnotes",
  elot_sort: "eLOT Sort",
  rdi: "RDI",
  utc_offset: "UTC Offset",
  zip_type: "ZIP Type",
  default_city_name: "Default City",
  county_fips: "County FIPS",
  elot_sequence: "eLOT Sequence",
  plus4_code: "+4 Code",
  delivery_point_check_digit: "Check Digit"
};

const ENRICHMENT_ORDER = [
  "county_name",
  "latitude",
  "longitude",
  "plus4_code",
  "rdi",
  "time_zone",
  "vacant",
  "carrier_route",
  "cmra",
  "congressional_district",
  "default_city_name",
  "county_fips",
  "delivery_point",
  "delivery_point_check_digit",
  "dpv_footnotes",
  "elot_sequence",
  "elot_sort",
  "precision",
  "record_type",
  "utc_offset",
  "zip_type"
];

const TABLE_SWITCHING_CONTEXT_MENU_MIN_COUNT = 7;

const ActivityTrackingOrder = [
  "created_at",
  "mailed_at",
  "in_transit_at",
  "in_local_area_at",
  "processed_for_delivery_at",
  "re_routed_at",
  "returned_to_sender_at"
];

const ActivityTrackingLabelsMap = {
  created_at: "Processed",
  mailed_at: "Mailed",
  in_transit_at: "In Transit",
  in_local_area_at: "In Local Area",
  processed_for_delivery_at: "Processed for Delivery",
  re_routed_at: "Rerouted",
  returned_to_sender_at: "Returned to Sender"
};

const MailTypesMap = {
  usps_first_class: "1st Class",
  usps_standard: "Standard"
};

export {
  ENRICHMENT_HINTS,
  ENRICHMENT_MAP,
  ENRICHMENT_ORDER,
  TABLE_SWITCHING_CONTEXT_MENU_MIN_COUNT,
  ActivityTrackingOrder,
  ActivityTrackingLabelsMap,
  MailTypesMap
};
